import React from 'react';
import { Box } from '@mui/material';
import bannerDrMonitora from '../../../assets/images/drmonitora-hero-banner.png'

export const HeroSection = () => {
  return (
    <Box component={'section'}
      sx={{
        position: 'relative',
        padding: 0,
        overflow: 'hidden',
        background: '#2f3857',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 'calc((100vw - 1200px) / 2 + 120px)',
          height: '100%',
          background: '#00b4e4',
          zIndex: 0
        }
      }}>
      <Box sx={{
        maxWidth: '1200px',
        display: 'block',
        margin: '0 auto',
        position: 'relative',
        zIndex: 2,
        paddingTop: '80px',
        paddingBottom: 0
      }}>
        <Box
          component="img"
          src={bannerDrMonitora}
          alt="Carro sendo lavado profissionalmente"
          sx={{
            width: '100%',
            display: 'block'
          }}
        />
      </Box>
    </Box>
  );
};